var _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h88",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 384 486.881)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h88",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 384 330.6)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 16-31.934 40 47.901",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 181.333 319.956)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 40-56",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 181.333 447.867)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-40-56",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 234.667 447.867)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c31.27-2.05 56-28.06 56-59.86v-313c0-33.14-26.86-60-60-60h-248c-33.14 0-60 26.86-60 60v313c0 31.8 24.73 57.81 56 59.86",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(384 447.86)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h196c16.568 0 30 13.432 30 30v37c0 16.568-13.432 30-30 30H0c-16.568 0-30-13.432-30-30V30C-30 13.432-16.568 0 0 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(158 400)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.9ba883f1a5ce0c7d09942ba5a746e717.svg";
export { ForwardRef as ReactComponent };